namespace advisorop.components.meetinghub {
    
    class MeetingHubAppController  {
        type: string;
        meetingId: string;
        participantId: string;

        constructor(private $location: ng.ILocationService, private $timeout: ng.ITimeoutService) {           
        }
        
        $onInit(): void {
            //debugger;
        }

        $onChanges(evt): void {
            //debugger;
            for (var key in evt) {
                if (key === "type" && this.type != undefined) {
                    //this.$location.path('/meetinghub/dashboard/' + this.type);
                    this.$timeout(function (meetingHubAppController) {
                        meetingHubAppController.$location.path('/meetinghub/dashboard/' + meetingHubAppController.type);
                        //meetingHubAppController.$location.search("type", meetingHubAppController.type);
                    }, 0, false, this);
                }
            }
        }

        $routerOnActivate(next, previous) {
        }
    }



    class MeetingHubApp implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = { 
                type: "@",
                meetingId: "@",
                participantId: "@"
            };
            this.controller = ["$location", "$timeout", MeetingHubAppController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/meeting-hub-module/views/meeting-hub-app.html';

            this.$routeConfig = [
                { path: "/dashboard/", component: "meetingHubDashboard", name: "Dashboard" },
                { path: "/createmeeting", component: "meetingCrud", name: "MeetingCrud" },
                { path: "/meeting/:meetingId/:participantId", component: "meetingDashboard", name: "MeetingDashboard" },
                { path: "/meeting/scheduler/:meetingId/:participantId", component: "investorMeetingScheduler", name: "InvestorMeetingScheduler" },
                //{ path: "/**", redirectTo: ["Dashboard", { dashboardtype: 'none' }] }
                { path: "/**", redirectTo: ["Dashboard"] }
            ];
        }
    }
    angular.module(Constants.APP).component("meetingHubApp", new MeetingHubApp());
}